export const SUPPORT = {
  FAQ_URL: `${process.env.REACT_APP_WEB_URL ?? 'https://app.daylotts.net'}/faq`,
  MAIL: 'support@daylotts.net',
};
